module.exports = {"apiURL":"https://hml.api.veloe.com.br","apiURLVeloe":"https://hml.api.veloe.com.br","apiAuthorization":"Basic Q3VzdG9tZXJDbGllbnQ6ZW9CWDYxaWc4Z0plTnVaRHpH","apiAuthorizationC6":"Basic UGFyY2Vpcm8tYzY6MlkhZlRlY0pOWmdScEJmbjJaa1pSJCZmeWp0NCFU","publicSite":"https://hml.fastalelo.com","brasPagURL":"https://transactionsandbox.pagador.com.br/post/api/public/v1","pfURL":"https://minha.hml.fastalelo.com","buildNumber":"1687550603538","authScope":"Customer.Info"}


//////////////////
// WEBPACK FOOTER
// ./src/alelo-logic/config.json
// module id = 221
// module chunks = 0